module.exports = __webpack_public_path__ + "static/media/Budgeteer.3fa453a4.png";